import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAllInternalUsersForSelectors } from '@/store';
import { handleInputValue } from '@/utils';

type Props = {
  value?: string;
  multiple?: boolean;
  placeholder?: string;
  allowClear?: boolean;
  disabled?: boolean;
  onChange?: (value: string) => void;
};

export const InternalUserSelector: React.FC<Props> = ({
  value,
  onChange,
  multiple,
  placeholder,
  allowClear = false,
  disabled = false
}) => {
  const { t } = useTranslation();
  const { internalUsers, isLoading } = useAllInternalUsersForSelectors();

  return (
    <Select
      showSearch
      onChange={onChange}
      allowClear={allowClear}
      mode={multiple ? 'multiple' : undefined}
      value={handleInputValue(value, multiple)}
      placeholder={placeholder ?? t('SELECT_USER')}
      options={internalUsers?.map(({ _id, name, lastName }) => ({
        label: `${name} ${lastName}`,
        value: _id
      }))}
      disabled={isLoading || disabled}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};
